import { useColorMode, useColorModeValue } from 'beskar/landing'
import classNames from 'classnames'
import clsx from 'clsx'
import { domAnimation, LazyMotion, m as motion } from 'framer-motion'
import React, { ComponentPropsWithRef } from 'react'


export const DarkModeSwitch = ({ size, className = '' }) => {
    const { toggleColorMode } = useColorMode()
    const SwitchIcon = useColorModeValue(MoonIcon, SunIcon)

    return (
        <LazyMotion features={domAnimation}>
            <GhostButton
                className={className}
                aria-label={`Switch color mode`}
                onClick={() => toggleColorMode()}
            >
                <SwitchIcon {...{ width: size, height: size }} />
            </GhostButton>
        </LazyMotion>
    )
}

export const SunIcon = ({ style, width, height, ...rest }) => {
    const variants = {
        initial: { scale: 0.6, rotate: -90 },
        animate: { scale: 1, rotate: 0, transition },
        // whileTap,
    }

    const props = {
        key: 'sun',
        whileTap: whileTap,
        // Centers the rotation anchor point vertically & horizontally
        style: {
            ...style,
            originX: '50%',
            originY: '50%',
        },
        ...rest,
    }

    const sizeDelta = 0

    return (
        <motion.svg
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'
            width={width + sizeDelta}
            height={height + sizeDelta}
            {...props}
        >
            <motion.path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                initial='initial'
                animate='animate'
                whileTap='whileTap'
                variants={variants}
                d='M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z'
            />
        </motion.svg>
    )
}

export const MoonIcon = ({ ...rest }) => {
    const variants = {
        initial: { scale: 0.6, rotate: 90 },
        animate: { scale: 1, rotate: 0, transition },
        whileTap,
    }

    return (
        <motion.svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 50 50'
            key='moon'
            style={{ opacity: 0.8 }}
            {...rest}
        >
            <motion.path
                d='M 43.81 29.354 C 43.688 28.958 43.413 28.626 43.046 28.432 C 42.679 28.238 42.251 28.198 41.854 28.321 C 36.161 29.886 30.067 28.272 25.894 24.096 C 21.722 19.92 20.113 13.824 21.683 8.133 C 21.848 7.582 21.697 6.985 21.29 6.578 C 20.884 6.172 20.287 6.022 19.736 6.187 C 10.659 8.728 4.691 17.389 5.55 26.776 C 6.408 36.163 13.847 43.598 23.235 44.451 C 32.622 45.304 41.28 39.332 43.816 30.253 C 43.902 29.96 43.9 29.647 43.81 29.354 Z'
                fill='currentColor'
                initial='initial'
                animate='animate'
                whileTap='whileTap'
                variants={variants}
            />
        </motion.svg>
    )
}

const transition = {
    type: 'spring',
    stiffness: 200,
    damping: 10,
}

const whileTap = {
    scale: 0.95,
    rotate: 15,
}

export function GhostButton ({
    className,
    ...rest
}: ComponentPropsWithRef<'button'>) {
    return (
        <button
            className={classNames(
                'p-2 py-[6px] ',
                'min-h-[34px] max-w-max shrink-0 items-center justify-center font-medium',
                'flex appearance-none gap-2 ease-in-out active:opacity-100',
                'duration-300 whitespace-nowrap rounded transition-all hover:bg-gray-100 dark:bg-gray-800 bg-gray-100 dark:hover:bg-gray-800',
                className,
            )}
            type='button'
            {...rest}
        />
    )
}
